import { EmailContact } from './emailContact';

export class SendEmailContactInput {
  emailContact?: EmailContact;
}
